import { filter, map, mergeMap, switchMap } from 'rxjs/operators';

import { ViewStatus } from '../../enums';
import * as mapActions from '../actions/map.actions';
import * as userActions from '../actions/user.actions';
import * as agencyActions from '../actions/agency.actions';
import { errorPipe } from './epicsUtil';
import { from } from 'rxjs';
import UserService from '../../services/user.service';
import { parseAgency } from '../../parsers/agency.parser';

export const setMapLocationByCurrentUserEpic = (action$, store) =>
  action$.pipe(
    filter(userActions.fetchCurrentUserSuccess.match),
    filter(() => store.value.user.model.facilities.length > 0 && store.value.route.status === ViewStatus.CREATE),
    map(() => mapActions.setMapLocationByCurrentUser(store.value)),
    errorPipe,
  );

export const setPreferredFacilityEpic = (action$, store) =>
  action$.pipe(
    filter(userActions.selectPreferredFacility.match),
    filter(() => store.value.route.status === ViewStatus.CREATE),
    switchMap(action => {
      const userState = store.value.user;
      const userId = userState.model.id;
      let preferredFacility;
      let servicePromise;
      let requesterAgency;

      if (action.payload) {
        preferredFacility = userState.facilities.find(facility => facility.id === action.payload);
        servicePromise = UserService.setPreferredUserFacility(userId, action.payload);
        requesterAgency = preferredFacility.requesterAgency;
      } else {
        servicePromise = UserService.unsetAllPreferredUserFacilities(userId);
      }

      return from(servicePromise).pipe(
        mergeMap(() => {
          if (requesterAgency) {
            return [
              userActions.updatePreferredFacility(preferredFacility),
              agencyActions.fetchPlace(parseAgency(requesterAgency)),
              agencyActions.getPickupLocationByAgency(),
            ];
          }
          return [userActions.updatePreferredFacility(null), agencyActions.clearAgency()];
        }),
      );
    }),
    errorPipe,
  );
